/* eslint-disable @typescript-eslint/no-explicit-any */
import { Stack, Typography } from '@mui/material';
import { RootState } from 'packages/blu-booking/src/store';
import { Scheduler } from './UI/Scheduler';
import { memo, useMemo } from 'react';
import { useSchedulerData } from './hooks/useSchedulerData';
import { useSelector } from 'react-redux';
import { CalendarLoader } from '../../UI/CalendarLoader/CalendarLoader';

/**
 * Wrapper del calendario User.
 * Usa useSchedulerData per il data fetching e gestisce
 * il rendering condizionale (nessun utente per il PdV).
 */
export const UserCalendarInner = memo(
  function UserCalendarInner(): JSX.Element {
    const { selectedDate, selectedPointOfSale } = useSelector(
      (state: RootState) => state.bluBookingUserCalendar
    );

    const { calendarPointOfSale, shiftPointOfSale, isLoading } =
      useSchedulerData({
        selectedDate,
        selectedPointOfSale,
      });

    const GetContent = useMemo(() => {
      if (isLoading) {
        return (
          <Stack
            alignItems="center"
            justifyContent="center"
            direction="row"
            flex="1"
            sx={{
              height: '100%',
              width: '100%',
              backgroundColor: 'var(--base-foreground-color) ',
            }}
          />
        );
      }
      // Mostra messaggio se non ci sono utenti per il PdV selezionato
      if (
        !isLoading &&
        calendarPointOfSale &&
        shiftPointOfSale &&
        ((calendarPointOfSale as any).length === 0 ||
          (shiftPointOfSale as any).length === 0)
      ) {
        return (
          <div style={{ height: '100%' }}>
            <Stack
              alignItems="center"
              justifyContent="center"
              direction="row"
              flex="1"
              sx={{ height: '100%', width: '100%' }}
            >
              <Typography fontWeight="bold">
                Nessun utente per il punto vendita selezionato
              </Typography>
            </Stack>
          </div>
        );
      }
      return (
        <Scheduler
          calendarPointOfSale={calendarPointOfSale}
          shiftPointOfSale={shiftPointOfSale}
        />
      );
    }, [calendarPointOfSale, isLoading, shiftPointOfSale]);

    return (
      <div style={{ height: '100%' }}>
        {GetContent}
        <CalendarLoader open={isLoading} />
      </div>
    );
  }
);
